export const routes = {
  index: '/',
  tokenLogin: '/token/login',
};
